import styled from 'styled-components'
import { breakpoints } from './../../../../../constants'
import {
	BLUE,
	PRIMARY_COLOR,
	LIGHTGRAY,
	LIGHTERGRAY,
	PRIMARY_LIGHT,
} from '../../../../../styles/colors.style'

const imageHeight = '192px'

const StyledProductImage = styled.div`
	align-items: center;
	border: 1px solid ${LIGHTGRAY};
	border-radius: 5px;
	display: flex;
	height: ${imageHeight};
	justify-content: center;
	margin-bottom: 10px;
	position: relative;
	transition: border-color 0.2s;
	width: calc(50% - 10px);

	& > img {
		max-height: 100%;
		max-width: 100%;
	}

	.close-sign {
		background: white;
		border-radius: 50%;
		color: ${PRIMARY_COLOR};
		height: 20px;
		padding: 3px;
		position: absolute;
		right: 10px;
		text-align: center;
		top: 10px;
		transform: rotate(45deg);
		transition: color 0.2s;
		width: 20px;

		&:hover {
			color: ${PRIMARY_LIGHT};
		}
	}

	.main-image {
		background: white;
		border-radius: 50%;
		color: ${PRIMARY_COLOR};
		height: 20px;
		padding: 3px;
		position: absolute;
		right: 40px;
		text-align: center;
		top: 10px;
		transition: color 0.2s;
		width: 20px;
	}

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		width: calc(25% - 10px);
	}
`

const StyledContainer = styled.div`
	align-items: center;
	display: flex;
	flex-wrap: wrap;
	width: 100%;

	.item {
		box-sizing: border-box;
		margin-right: 10px;

		&:nth-child(2n + 2),
		&:last-child {
			margin-right: 0;
		}

		&:hover {
			border-color: ${BLUE};
		}
	}

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		.item {
			&:nth-child(4n + 4) {
				margin-right: 0;
			}
			&:nth-child(2n + 2) {
				margin-right: 10px;
			}
		}
	}
`

const StyledImagePicker = styled.div`
	align-items: center;
	background: ${LIGHTERGRAY};
	border: 1px dashed ${LIGHTGRAY};
	border-radius: 5px;
	box-sizing: border-box;
	color: ${BLUE};
	display: flex;
	flex-direction: column;
	font-size: 20px;
	height: ${imageHeight};
	justify-content: center;
	margin-bottom: 10px;
	margin-right: 10px;
	transition: border-color 0.2s;

	&:hover {
		border-color: ${BLUE};
	}
`

const ButtonContainer = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-bottom: 15px;
`

export {
	ButtonContainer,
	StyledContainer,
	StyledImagePicker,
	StyledProductImage,
}
